<script>
import Gltf from '../snippets/Gltf'

export default {
  components: {
    Gltf
  }
}
</script>

<template>
  <gltf
    src="/models/ammo-box/scene.gltf"
    position="0 -0.9 0"
    :scale="0.35"
  />
</template>
